// EAKC Memory & Learning Loop — session_summarizer + episode_summarizer.
// Reuses the EAKCLearning neon house style; defines its own scene map.
export { COLORS, FONTS, SPRING } from "../EAKCLearning/constants";

export const FPS = 30;
export const WIDTH = 1920;
export const HEIGHT = 1080;

// 10 scenes · ~112s
export const SCENE = {
  cold:     { start:    0, duration: 240 }, //   0-  8s  — hook: your AI forgets
  title:    { start:  240, duration: 210 }, //   8- 15s  — title
  problem:  { start:  450, duration: 360 }, //  15- 27s  — stateless by default
  stage1:   { start:  810, duration: 450 }, //  27- 42s  — session_summarizer
  stage2:   { start: 1260, duration: 480 }, //  42- 58s  — episode_summarizer
  exampleA: { start: 1740, duration: 360 }, //  58- 70s  — one long chat → 1 episode
  exampleB: { start: 2100, duration: 360 }, //  70- 82s  — many chats → 1 skill
  cost:     { start: 2460, duration: 300 }, //  82- 92s  — cost discipline
  value:    { start: 2760, duration: 360 }, //  92-104s  — why it matters
  outro:    { start: 3120, duration: 240 }, // 104-112s  — distill, don't dump
} as const;

export const TOTAL_DURATION = 3360; // 112s @ 30fps

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
